import './person.scss';

import Person from './Person';

export default Person;
